// [전체 코드 미사용/주석 삭제 금지]
import React from 'react';
import {useNavigate} from "react-router-dom";

// Image imports
import gpsIcon from 'assets/images/icon/gps-icon.svg';
import locationIcon from 'assets/images/icon/location-icon.svg';
import rightarrow from 'assets/images/icon/arrow-right-icon.svg';

/**
 * Home 페이지 하단에 위치하는 현재 위치 및 지점 선택 바 컴포넌트
 * @param {object} props
 * @param {function} props.onLocationSelectClick - 지점 선택 버튼 클릭 핸들러
 * @param {function} props.onGpsClick - 현재 위치 버튼 클릭 핸들러
 */
function LocationBar({onLocationSelectClick, onGpsClick, branchName = "지점 선택"}) {
    const navigate = useNavigate();

    return (
        <div className="homeHeaderLocationField" style={staticStyles.homeHeaderLocationField}>
            <div className="nowLocation" style={staticStyles.nowLocation}>
                <img src={gpsIcon} alt="GPS" style={staticStyles.gpsIcon}/>
                <button className="gpsButton" style={staticStyles.gpsButton} onClick={onGpsClick}>
                    {/* [수정] props로 받은 branchName 표시 */}
                    {branchName}
                </button>
            </div>
            <div className="locationSelect" style={staticStyles.locationSelect} onClick={() => navigate('/branch')}>
                <img src={locationIcon} alt="Location" style={staticStyles.locationIcon}/>
                <button className="locationSelectButton" style={staticStyles.locationSelectButton}>
                    지점 선택
                </button>
            </div>
        </div>
    );
}

// [!! LocationBar 전용 스타일 !!]
/** @type {React.CSSProperties} */
const staticStyles = {
    // 이 스타일은 AppHeader의 homeHeaderField 하단에 바로 붙습니다.
    homeHeaderLocationField: {
        paddingTop: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    nowLocation: {display: 'flex', alignItems: 'center', gap: '8px'},
    gpsIcon: {width: '24px', height: '24px'},
    gpsButton: {
        background: 'none',
        border: 'none',
        padding: 0,
        margin: 0,
        font: 'inherit',
        cursor: 'pointer',
        textAlign: 'inherit',
        display: 'inline',
        textDecoration: 'none',
        fontFamily: 'Pretendard',
        fontWeight: 700,
        fontSize: '16px',
        color: '#FFFFFF',
    },
    headerArrowIcon: {width: '10px', height: '10px', color: '#FFFFFF', border: '1.5px', align: 'center'},
    locationSelect: {display: 'flex', alignItems: 'center', gap: '8px'},
    locationIcon: {width: '22px', height: '22px'},
    locationSelectButton: {
        background: 'none',
        border: 'none',
        padding: 0,
        margin: 0,
        font: 'inherit',
        cursor: 'pointer',
        textAlign: 'inherit',
        display: 'inline',
        textDecoration: 'none',
        fontFamily: 'Pretendard',
        fontWeight: 500,
        fontSize: '14px',
        color: '#D0D0D0',
    },
};

export default LocationBar;